import React from 'react';
import DropdownBase from '../DropdownBase';
const base = function () {
  let type = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 'items';
  return "".concat(process.env.REACT_APP_BASE_URL, "/").concat(type).concat(process.env.REACT_APP_URL_ENV, "/");
};
const name = 'QA';
const items = [{
  link: "".concat(base(), "item_batches"),
  label: 'Item Batches'
}, {
  link: "".concat(base(), "item_batches_released"),
  label: 'Item Batches Released'
}, {
  link: "".concat(base('contracts'), "storage_units"),
  label: 'Storage Units'
}];
const Qa = () => /*#__PURE__*/React.createElement(DropdownBase, {
  name: name,
  items: items
});
export default Qa;